import script from "./AppLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLogo.vue?vue&type=script&lang=ts&setup=true"

import "./AppLogo.vue?vue&type=style&index=0&id=909d1286&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909d1286"]])

export default __exports__